import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import PositioningOnboarding from "@/components/dashboard/PositioningOnboarding";

const Onboarding = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [clientId, setClientId] = useState<string | null>(null);
  const [recipientEmail, setRecipientEmail] = useState<string | null>(null);

  useEffect(() => {
    (async () => {
      const {
        data: { session },
      } = await supabase.auth.getSession();

      if (!session) {
        navigate("/auth", { replace: true });
        return;
      }

      setRecipientEmail(session.user.email ?? null);

      const { data: clients } = await supabase
        .from("clients")
        .select("id, positioning_completed_at, website_url")
        .eq("user_id", session.user.id)
        .order("created_at", { ascending: true });

      if (!clients || clients.length === 0) {
        navigate("/dashboard", { replace: true });
        return;
      }

      // Prefer the first client that has a website URL (matches Dashboard logic).
      const target =
        clients.find((c) => c.website_url && c.website_url.trim() !== "") ?? clients[0];

      if (target.positioning_completed_at) {
        navigate("/dashboard", { replace: true });
        return;
      }

      setClientId(target.id);
      setLoading(false);
    })();
  }, [navigate]);

  if (loading || !clientId) {
    return <div className="min-h-screen bg-background" />;
  }

  return (
    <div
      className="min-h-screen bg-background text-foreground"
      style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
    >
      <div
        className="pointer-events-none fixed inset-0 z-0"
        style={{
          background:
            "radial-gradient(ellipse at 15% 10%, hsl(var(--primary) / 0.06) 0%, transparent 55%), radial-gradient(ellipse at 85% 85%, hsl(262 83% 58% / 0.06) 0%, transparent 55%)",
        }}
      />
      <PositioningOnboarding
        clientId={clientId}
        recipientEmail={recipientEmail}
        onComplete={() => navigate("/dashboard", { replace: true })}
      />
    </div>
  );
};

export default Onboarding;
